import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DimensionHero from "../components/home/DimensionHero";
import Manifesto from "../components/home/Manifesto";
import Multidimensional from "../components/home/Multidimensional";
import { NowInMotion, SupportersPreview, CompleteSetSection, DimensionVTeaser, NewsletterSection } from "../components/home/JourneySections";
import { ArtistStatement, SelectedVisuals, FinalStatement } from "../components/home/HomeSections";
import Marquee from "../components/Marquee";
import { useAuth } from "../context/AuthContext";
import { getDimensions, getHero, getRelease, getFeatured, getReleases, getVisuals, getActiveWhispers, getHomepage, getSupporters, getCompleteSet } from "../lib/api";

export default function Home() {
  const location = useLocation();
  const { user } = useAuth();
  const isPreview = new URLSearchParams(location.search).get("preview") === "1";
  const [config, setConfig] = useState(null);
  const [heroSlides, setHeroSlides] = useState([]);
  const [dimensions, setDimensions] = useState([]);
  const [featured, setFeatured] = useState(null);
  const [releases, setReleases] = useState([]);
  const [visuals, setVisuals] = useState([]);
  const [whispers, setWhispers] = useState([]);
  const [supporters, setSupporters] = useState([]);
  const [completeSet, setCompleteSet] = useState(null);

  useEffect(() => {
    document.title = "Motion & Meaning — Enter the Dimensions";
    getHomepage(isPreview).then(setConfig).catch(() => getHomepage(false).then(setConfig).catch(() => {}));
    getHero().then(setHeroSlides).catch(() => {});
    getDimensions().then(setDimensions).catch(() => {});
    getReleases().then(setReleases).catch(() => {});
    getVisuals().then(setVisuals).catch(() => {});
    getActiveWhispers().then(setWhispers).catch(() => {});
    getSupporters().then((s) => setSupporters(s.supporters || s || [])).catch(() => {});
    getCompleteSet().then(setCompleteSet).catch(() => {});
  }, [isPreview]);

  useEffect(() => {
    const slug = config?.featuredReleaseSlug;
    if (slug) getRelease(slug).then(setFeatured).catch(() => getFeatured().then(setFeatured).catch(() => {}));
    else getFeatured().then(setFeatured).catch(() => {});
  }, [config]);

  const sections = config?.sectionsEnabled || {};

  return (
    <div data-testid="home-page">
      {isPreview && (
        <div className="fixed top-0 left-0 right-0 z-[80] bg-gold text-black font-mono text-[10px] tracking-[0.3em] text-center py-1.5" data-testid="preview-banner">
          DRAFT PREVIEW — NOT LIVE
        </div>
      )}
      {/* 1. Interactive Dimension Carousel Hero */}
      {heroSlides.length > 0 && <DimensionHero slides={heroSlides} />}
      {/* 2. Multidimensional project map */}
      <Manifesto />
      {dimensions.length > 0 && <Multidimensional dimensions={dimensions} whispers={whispers} />}
      {/* 3+4. Featured music + Lyrics & Meaning pathways */}
      <NowInMotion heading={config?.nowInMotionHeading} featured={featured} releases={releases} />
      {/* 5. Visuals */}
      <SelectedVisuals visuals={visuals} featuredId={config?.featuredVisualId} />
      {/* 6. Supporters Wall preview */}
      {sections.supporters !== false && <SupportersPreview supporters={supporters} />}
      {/* 7. Complete Set */}
      {sections.completeSet !== false && <CompleteSetSection set={completeSet} />}
      {/* 8. Dimension V teaser */}
      {sections.dimensionV !== false && <DimensionVTeaser user={user || null} />}
      {/* 9. About */}
      <ArtistStatement heading={config?.artistHeading} copy={config?.artistCopy} />
      <Marquee />
      {/* 10. Newsletter */}
      {sections.newsletter !== false && <NewsletterSection heading={config?.newsletterHeading} copy={config?.newsletterCopy} />}
      {/* 11. Final CTA */}
      <FinalStatement statement={config?.finalStatement} cta={config?.finalCta} />
    </div>
  );
}
